import React from 'react';
import {Nav} from 'react-bootstrap';

interface ConditionalNavProps {
  variant?: 'tabs' | 'pills' | 'underline';
  role?: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

const ConditionalNav: React.FC<ConditionalNavProps> = ({ 
    children, 
    variant = 'pills',
    role = 'tablist',
    className = 'bg-white mb-3',
    ...props 
}) => {
    const hasChildren = React.Children.count(children) > 0;

    if (!hasChildren) {
        return null;
    }

    return (
        <Nav variant={variant} role={role} className={className} {...props}>
            {children}
        </Nav>
    );
};

export default ConditionalNav;
